import React from 'react';

import { Button } from '@components';
import { useHistory } from 'react-router-dom';
import useLayoutContext from '@hooks/useLayoutContext';
import { FCWithChildren } from '@types';
import classNames from 'classnames';

type GuestButtonsProps = {
  captivePortal?: boolean;
};

const GuestButtons: FCWithChildren<GuestButtonsProps> = ({ captivePortal = false }) => {
  const history = useHistory();
  const { loginToCaptivePortal, portalAccessUrl } = useLayoutContext();
  return (
    <div className={classNames(captivePortal && 'flex justify-around gap-3')}>
      <Button
        layout="secondary"
        className={classNames({
          'w-full mt-3': true,
          'sm:w-auto p-2': !captivePortal,
        })}
        onClick={() => history.goBack()}
      >
        {captivePortal ? 'Go Back' : 'Cancel'}
      </Button>
      <Button
        layout={captivePortal ? undefined : 'secondary'}
        className={classNames({
          'w-full mt-3': true,
          'sm:w-auto p-2 float-right': !captivePortal,
        })}
        onClick={() => {
          if (captivePortal) {
            loginToCaptivePortal();
          } else {
            history.push(portalAccessUrl('/guest-confirm'));
          }
        }}
      >
        Continue
      </Button>
    </div>
  );
};

export default GuestButtons;
